export default "__VITE_ASSET__Dv5CaboI__"